module.exports = __webpack_public_path__ + "static/media/SourceHanSerifCN-Medium.2820a9c4.svg";